import { z } from 'zod';

// Shared enumerations for environment typing across frontend and backend
export const EnvironmentEnum = z.enum([
  'LOCAL',
  'DEMO',
  'STAGE',
  'PREPROD',
  'PROD',
  'SANDBOX',
  'CI',
] as const);

export type Environment = z.infer<typeof EnvironmentEnum>;

const NodeEnvEnum = z.enum(['development', 'production', 'test'] as const);

export const BackendBaseEnvSchema = z.object({
  // Environment configuration
  ENVIRONMENT: EnvironmentEnum,
  NODE_ENV: NodeEnvEnum,
  PRODUCTION_URL: z.string().url(),

  // Server / Infra
  DATABASE_URL: z.string(),
  TEST_DATABASE_URL: z.string().optional(),
});

type BackendBaseEnv = z.infer<typeof BackendBaseEnvSchema>;

/**
 * Since packages are used across multiple services, we don't know which environment variables are needed
 * This function returns the environment variables for the backend base schema for use in database package
 * @returns
 */
export function getBackendBaseEnvVariablesPackagesOnly(): BackendBaseEnv {
  return BackendBaseEnvSchema.parse(process.env);
}
